module.exports = __webpack_public_path__ + "img/REU.69c3c535.svg";